import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = { class: "my-4 ml-auto d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_BuildingItem = _resolveComponent("BuildingItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogAddEditBuilding = _resolveComponent("DialogAddEditBuilding")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
            class: "p-button-rounded p-button-raised p-button--m",
            onClick: _ctx.toggleAddEditBuilding
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("entrancePlant.newBuilding")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _createVNode(_component_ElScrollbar, { class: "building-card-list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildings, (building, index) => {
          return (_openBlock(), _createBlock(_component_BuildingItem, {
            class: "building-card mt-3",
            key: index,
            building: building,
            onClick: ($event: any) => (_ctx.goToBuilding(building))
          }, null, 8, ["building", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_DialogAddEditBuilding, {
      isVisible: _ctx.isVisibleAddEditBuilding,
      onHideDialog: _ctx.toggleAddEditBuilding,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "onHideDialog", "onUpdateList"])
  ], 64))
}